export const hasTextOverflow = (element: Element): boolean =>
  element && element.scrollWidth > Math.floor(element.clientWidth);
